import React from 'react';

const Property = ({ label, value }) => {
    return (
      <div className="flex p-1">
        <div className="flex-1  border-b border-gray-200">
          <span className="text-sm text-gray-700">
            {label}
          </span>
        </div>
        <div className="flex-1 border-b border-gray-200">
          <span className="ml-1 sm:text-xl">
            {value}
          </span>
        </div>
      </div>
    )
  };

export default Property;